import FieldLabel from './ui/FieldLabel'
import React from 'react';
import Select from './ui/Select';


const Dropdown = ({ options, clearable, isMulti, disabled, customStyle, value, setValue, required, placeholder, label, description, errorFields = [], name, ...selectProps }) => {

    let style = customStyle || {}
    return (<div className="flex-wrap">
        <FieldLabel className={label ? 'fieldLabel' : 'fieldLabel fieldLabelEmpty'} style={style}>{label || ''} {required && <span className="uiRequired" style={{ color: '#dc2626' }}>*</span>}</FieldLabel>
        {description && <FieldLabel className="fieldDescription" style={style}>{description || ''}</FieldLabel>}
        <Select
            isMulti={!!isMulti}
            isDisabled={disabled}
            className={errorFields.includes(name) ? 'basic-single-error' : "basic-single"}
            classNamePrefix="select"
            isClearable={!!clearable}
            placeholder={placeholder || ''}
            value={value}
            options={options}
            onChange={setValue}
            // Panels clip their content to keep rounded corners, which would cut
            // the menu off. Render it in a body portal so it floats above.
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            styles={{ menuPortal: base => ({ ...base, zIndex: 12000 }) }}
            {...selectProps}
        />
    </div>)
}

export default Dropdown
